import React from 'react';
import ReactTable from 'react-table';
import withFixedColumns from 'react-table-hoc-fixed-columns';
import { Message, WebMediaQuery } from '@aperza/ui';
import SellerGroupModelListPagination from '../sellerGroupModel/SellerGroupModelListPagination';
import SellerShippingTooltip from './SellerShippingTooltip';
import { withTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
const ReactTableFixedColumns = withFixedColumns(ReactTable);
class SellerShippingPrice extends React.Component {
    createColumns(tableConfig) {
        let columns = [
            {
                Header: React.createElement(Message, { messageId: "seller.shippingFee.heading" }),
                id: 'prefecture',
                accessor: (d) => d,
                Cell: (props) => (React.createElement(React.Fragment, null,
                    React.createElement(WebMediaQuery, { desktopOnly: true },
                        React.createElement("div", null,
                            props.value.locationName,
                            React.createElement(SellerShippingTooltip, { shippingInfo: props.value, shippingType: "weight" }),
                            React.createElement(SellerShippingTooltip, { shippingInfo: props.value, shippingType: "quantity" }))))),
                width: 250,
                fixed: 'left',
            },
        ];
        // Assigning Columns
        let baseShippingFeesHeadings = [];
        tableConfig.sortedBaseShippingFeesColumns.forEach((col, index) => {
            baseShippingFeesHeadings.push({
                Header: col,
                id: 'baseShipping_' + index,
                accessor: (d) => d.baseShippingFees[col] != 0 ? (d.baseShippingFees[col]) : (React.createElement(Message, { messageId: "seller.shippingFee.free" })),
                // width: 150,
            });
        });
        columns.push({
            accessor: (d) => d.baseShippingFees,
            columns: baseShippingFeesHeadings,
        });
        return columns;
    }
    // CONSTRUCTOR
    constructor(props) {
        super(props);
    }
    render() {
        const tableConfig = this.props.tableConfig;
        if (tableConfig && tableConfig.data && tableConfig.data.length > 0) {
            // Rendering begin
            console.log('this.data', tableConfig.data);
            if (!isMobile) {
                return (React.createElement("div", null,
                    React.createElement(ReactTableFixedColumns, { data: tableConfig.data, columns: this.createColumns(tableConfig), sortable: false, resizable: false, footer: false, className: "shipping-fee-table table-vh-hover -highlight", PaginationComponent: SellerGroupModelListPagination, showPageSizeOption: false, showPageJump: false, defaultPageSize: 10 })));
            }
            else {
                return tableConfig.data.map((prefecture, index) => {
                    let tableData = [];
                    tableConfig.sortedBaseShippingFeesColumns.forEach((col, index) => {
                        tableData.push(React.createElement("tr", { key: 'mtrow_' + index },
                            React.createElement("td", null, col),
                            React.createElement("td", null, prefecture.baseShippingFees[col] ? (prefecture.baseShippingFees[col]) : (React.createElement(Message, { messageId: "seller.shippingFee.free" })))));
                    });
                    return (React.createElement("div", { className: "shipping-fee-group-mobile", key: 'pref' + index },
                        React.createElement("h2", null, prefecture.locationName),
                        React.createElement("table", null,
                            React.createElement("thead", null,
                                React.createElement("tr", null,
                                    React.createElement("th", null,
                                        React.createElement(React.Fragment, null,
                                            React.createElement(Message, { messageId: "seller.shippingFee.heading" }),
                                            React.createElement(SellerShippingTooltip, { shippingInfo: prefecture, shippingType: "weight" }))),
                                    React.createElement("th", null,
                                        React.createElement(React.Fragment, null,
                                            React.createElement(Message, { messageId: "seller.shippingFee.shippingFee" }),
                                            React.createElement(SellerShippingTooltip, { shippingInfo: prefecture, shippingType: "quantity" }))))),
                            React.createElement("tbody", null, tableData))));
                });
            }
        }
        else {
            console.log('No Shipping Price Data Found');
            return null;
        }
    }
}
export default withTranslation()(SellerShippingPrice);
